import AdaptiveButton from './AdaptiveButton';

export default AdaptiveButton;
